import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";
import segmentFerry from "@/assets/segment-ferry.jpg";
import segmentTug from "@/assets/segment-tug.jpg";
import segmentMerchant from "@/assets/segment-merchant-new.jpg";
import segmentFishing from "@/assets/fishing-cover.png";
import segmentCtv from "@/assets/segment-ctv-new.jpg";
import segmentPilot from "@/assets/segment-pilot.jpg";

const SegmentsSection = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation('home');

  const segments = [
    { title: t('segments.ferry'), slug: "ferry", image: segmentFerry, description: t('segments.ferryDesc') },
    { title: t('segments.fishing'), slug: "fishing", image: segmentFishing, description: t('segments.fishingDesc') },
    { title: t('segments.merchant'), slug: "merchant", image: segmentMerchant, description: t('segments.merchantDesc') },
    { title: t('segments.ctv'), slug: "ctv", image: segmentCtv, description: t('segments.ctvDesc') },
    { title: t('segments.tug'), slug: "tug", image: segmentTug, description: t('segments.tugDesc') },
    { title: t('segments.pilot'), slug: "pilot", image: segmentPilot, description: t('segments.pilotDesc') },
  ];

  return (
    <section id="vessel-segments" className="py-20 md:py-28 bg-surface-light">
      <div className="container mx-auto px-6">
        <motion.div initial={isMobile ? false : { opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: isMobile ? 0 : 0.7 }} className="mb-16">
          <p className="text-xs font-semibold tracking-widest uppercase text-foreground mb-4">{t('segments.label')}</p>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-background">{t('segments.heading')}</h2>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {segments.map((segment, i) => (
            <motion.div key={segment.slug} initial={isMobile ? false : { opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: isMobile ? 0 : 0.5, delay: isMobile ? 0 : i * 0.08 }}>
              <Link to={`/segments/${segment.slug}`} className="group flex flex-col h-full">
                <div className="relative aspect-[4/3] overflow-hidden mb-4">
                  <img src={segment.image} alt={`${segment.title} vessel`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="mb-2">
                  <h3 className="font-display font-bold text-background text-lg tracking-wide">{segment.title}</h3>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed mb-2 flex-1">{segment.description}</p>
                <span className="text-sm font-medium text-primary group-hover:underline inline-flex items-center gap-1 mt-auto" aria-label={`Read about ${segment.title} solutions`}>
                  {t('readMore', { ns: 'common' })} <ArrowRight size={14} aria-hidden="true" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SegmentsSection;
